import fileSelector from '../app/file_selector';

const contentTypeImage = 'image/*';
const contentTypePdf = 'application/pdf';

$(document).on('ready turbolinks:load', () => {
  const $photosContainer = $('#vehicle-photos-container');
  const $filesContainer = $('#vehicle-files-container');
  const templatePhoto = $('.vehicle-photos').last().clone();
  const templateFile = $('.vehicle-files').last().clone();

  const initFileRemover = ($elem) => {
    $elem.off('click').on('click', () => {
      $elem.parents('.media-upload.photo').remove();
    });
  };
  const initFileSelector = ($elem, $container, template, type, contentTypes) => {
    fileSelector({
      uploadButton: $elem,
      idInput: $elem.siblings('input'),
      type,
      contentTypes,
      button: $('button#save-vehicle-button'),
      uploadCallback: () => {
        // Add upload block
        const $template = template.clone();
        $container.append($template);
        initFileSelector($template.find('.vehicle-resource'), $container, template, type, contentTypes);
        // Replace existing upload with trash
        $elem.find('i').removeClass('fa-upload').addClass('fa-trash');
        initFileRemover($elem);
      },
    });
  };

  $('.vehicle-photo').each((index, elem) => initFileSelector($(elem), $photosContainer, templatePhoto, 'vehicle_pics', contentTypeImage));
  $('.vehicle-file').each((index, elem) => initFileSelector($(elem), $filesContainer, templateFile, 'vehicle_files', contentTypePdf));
  $('.vehicle-photo-trash').each((index, elem) => initFileRemover($(elem)));
  $('.vehicle-file-trash').each((index, elem) => initFileRemover($(elem)));
});
